export var dataHooks;
(function (dataHooks) {
    dataHooks["progressIndicator"] = "progress-indicator";
    dataHooks["successIcon"] = "success-icon";
    dataHooks["errorIcon"] = "error-icon";
    dataHooks["progressArcForeground"] = "progressarc-foreground";
    dataHooks["progressArcBackground"] = "progressarc-background";
})(dataHooks || (dataHooks = {}));
//# sourceMappingURL=constants.js.map